import { useDataStore, useFilterStore } from "@/stores";
import { useEffect } from "react";

const DefaultFilterHandler = () => {
    const activeVersion = useFilterStore((state) => state.activeVersion);

    const disciplines = useDataStore((state) => state.disciplines);
    const software = useDataStore((state) => state.software);
    const useCases = useDataStore((state) => state.useCases);

    const activeDisciplines = useFilterStore((state) => state.activeDisciplines);
    const setActiveDisciplines = useFilterStore((state) => state.setActiveDisciplines);

    const activeIfcVersion = useFilterStore((state) => state.activeIfcVersion);
    const setActiveIfcVersion = useFilterStore((state) => state.setActiveIfcVersion);

    const activeSoftware = useFilterStore((state) => state.activeSoftware);
    const setActiveSoftware = useFilterStore((state) => state.setActiveSoftware);

    const activeUseCases = useFilterStore((state) => state.activeUseCases);
    const setActiveUseCases = useFilterStore((state) => state.setActiveUseCases);

    useEffect(() => {
        if (!activeVersion) return;

        if (disciplines[activeVersion]) {
            const validDisciplines = disciplines[activeVersion].map((d) => d.id);
            const filteredDisciplines = activeDisciplines.filter((id) => validDisciplines.includes(id));
            setActiveDisciplines(filteredDisciplines);
        }

        if (software[activeVersion]) {
            const validIfcVersions = software[activeVersion].filter((x) => x.isIfc);
            const validSoftware = software[activeVersion].filter((x) => !x.isIfc);

            if (validIfcVersions.every((x) => x.id !== activeIfcVersion))
                setActiveIfcVersion(validIfcVersions.find((x) => x.defaultActive)?.id || null);

            if (validSoftware.every((x) => x.id !== activeSoftware))
                setActiveSoftware(validSoftware.find((x) => x.defaultActive)?.id || null);
        }

        if (useCases[activeVersion]) {
            const validUseCases = useCases[activeVersion].map((uc) => uc.id);
            const filteredUseCases = activeUseCases.filter((id) => validUseCases.includes(id));
            if (filteredUseCases.length > 0) setActiveUseCases(filteredUseCases);
            else {
                const minimumRequiredUseCase = useCases[activeVersion].find((uc) => uc.code.startsWith("UC 00"));
                if (minimumRequiredUseCase) {
                    setActiveUseCases([minimumRequiredUseCase.id]);
                } else {
                    setActiveUseCases([]);
                }
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeVersion, disciplines, software, useCases]);

    return null;
};

export default DefaultFilterHandler;
